import {Context} from "@hotwired/stimulus";
import Debug from 'debug';
import {ReactWrapperController} from "@root/server/client/esweb/src/lib/stimulus/ReactWrapperController.ts";
import {Toaster} from "@root/server/client/esweb/components/ui/sonner.tsx";
import React from "react";

export const name = 'toast-container';

const debug = Debug(`app:${name}`);

export default class extends ReactWrapperController {

    constructor(context: Context) {
        debug('constructor')
        super(context, (props) =>
                <Toaster
                    {...{position: 'top-right', ...props}}
                    richColors
                />
            , {permanent: true});
    }


}
